export default __webpack_public_path__ + "static/media/Resume_Orfeas_Kypris_2021.4d0b2bb3.pdf";